<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Authentication Process Policy</h1>
        <p class="desc-text">Effective Date: August 5, 2025</p>

        <section class="content-section">
            <h2 class="section-title">1. Eligible Categories</h2>
            <p class="desc-text">Authentication services are currently available for selected categories including:</p>
            <ul class="policy-list">
                <li>luxury handbags</li>
                <li>luxury accessories</li>
                <li>premium sneakers</li>
            </ul>
            <p class="desc-text">Additional categories may be introduced in the future.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">2. Authentication Methods</h2>
            <p class="desc-text">Authentication review may involve:</p>
            <ul class="policy-list">
                <li>visual product analysis</li>
                <li>AI-assisted review tools</li>
                <li>expert-assisted assessment</li>
                <li>independent third-party review support</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">3. Third-Party Service Providers</h2>
            <p class="desc-text">Certain authentication reviews may be supported by independent authentication partners operating under service-level agreements.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">4. Review Outcomes</h2>
            <p class="desc-text">Authentication review outcomes may include:</p>
            <ul class="policy-list">
                <li>consistent with authentication review standards</li>
                <li>unable to verify</li>
                <li>additional review required</li>
            </ul>
            <p class="desc-text">Authentication outcomes are professional review opinions only.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">5. No Financial Guarantee of Future Outcomes</h2>
            <p class="desc-text">Authentication results do not guarantee:</p>
            <ul class="policy-list">
                <li>future authenticity claims</li>
                <li>future resale value</li>
                <li>future transaction outcomes</li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckAuthenticationProcessPolicy'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
